import React from 'react'
import { CardSection, Heading } from './CardSection'
import { Item, UsageItemList } from './Item'

export type ItemsForChildProps = {
  items: Item[]
}

export const ItemsForChild = ({ items }: ItemsForChildProps) => {
  return (
    <CardSection>
      <Heading as="h3">子どもが使うもの</Heading>
      <UsageItemList items={items} />
    </CardSection>
  )
}
